import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { City, Country, State } from "country-state-city";
// import { updateProfile } from "../../../service/ProfileService";
import { PhoneInput } from "react-international-phone";
import {
  getAllRolelist,
  getMyProfile,
} from "../../../service/MyProfile/MyProfileService";

import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const Myprofile = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let countryData = Country.getAllCountries().map((item) => ({
    name: item?.name,
    countryCode: item?.isoCode,
  }));
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  const { logo } = props;
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("");
  const [profilePic, setProfilePic] = useState("");

  const [companyName, setCompanyName] = useState("");
  const [companyWebsiteUrl, setCompanyWebsiteUrl] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [jobTitle, setJob] = useState("");
  const [role, setRole] = useState("");
  const [roleList, setAllRoleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fullCountryData, setFullCountryData] = useState();
  const [fullStateData, setFullStateData] = useState();

  const [allData, setAllData] = useState({
    companyname: JSON.parse(localStorage.getItem("gs3_User")).companyName,
    companyurl: "",
    firstname: "",
    lastname: "",
    country: "",
    state: "",
    city: "",
    address: "",
    phone: "",
    email: JSON.parse(localStorage.getItem("gs3_User")).email,
    jobtitle: "",
    role: "",
    profilePic: getImage,
  });

  // console.log(getImage, profilePic, "allDATATADA");

  // console.log(JSON.parse(localStorage.getItem("gs3_User")).jobtitle, "allData");

  const onRole = (e) => {
    setRole(e.target.value);
  };

  //COUNTRY-STATE-CITY

  const onCountry = (val) => {
    const selectedIsoCode = val;
    // console.log("val0001", val);

    // Find the country object based on the selected isoCode
    const selectedCountry = countryData.find(
      (country) => country.countryCode === selectedIsoCode
    );

    // Update the country name and set state data
    setCountry(selectedIsoCode);
    setFullCountryData(selectedCountry);
    const AllState = State.getStatesOfCountry(selectedIsoCode).map((item) => ({
      name: item?.name,
      stateCode: item?.isoCode,
    }));
    setStateData(AllState);
  };

  const onState = (val) => {
    const selectedIsoCode = val;
    // console.log("valll22", val);
    setState(selectedIsoCode);
    const selectedState = stateData.find(
      (state) => state.stateCode === selectedIsoCode
    );
    setFullStateData(selectedState);

    setCityData(
      City.getCitiesOfState(
        country || JSON.parse(localStorage.getItem("gs3_User"))?.country,
        selectedIsoCode
      )
    );
  };

  // console.log("countrydata", country, countryData);

  const onCity = (e) => {
    setCity(e.target.value);
  };

  useEffect(() => {
    setAllData({
      companyname: JSON.parse(localStorage.getItem("gs3_User")).companyName,
      companyurl: JSON.parse(localStorage.getItem("gs3_User"))
        .companyWebsiteUrl,
      firstname: JSON.parse(localStorage.getItem("gs3_User")).firstName,
      lastname: JSON.parse(localStorage.getItem("gs3_User")).lastName,
      country: JSON.parse(localStorage.getItem("gs3_User")).country,
      countryCode: JSON.parse(localStorage.getItem("gs3_User"))?.countryCode,
      state: JSON.parse(localStorage.getItem("gs3_User")).state,
      stateCode: JSON.parse(localStorage.getItem("gs3_User"))?.stateCode,
      city: JSON.parse(localStorage.getItem("gs3_User")).city,
      address: JSON.parse(localStorage.getItem("gs3_User")).address,
      phone: JSON.parse(localStorage.getItem("gs3_User")).phone,
      email: JSON.parse(localStorage.getItem("gs3_User")).email,
      jobtitle: JSON.parse(localStorage.getItem("gs3_User")).jobtitle,
      role: JSON.parse(localStorage.getItem("gs3_User")).jobRole,
      roleId: JSON.parse(localStorage.getItem("gs3_User")).roleId,
    });
    setCity(JSON.parse(localStorage.getItem("gs3_User")).city);
    setCountry(JSON.parse(localStorage.getItem("gs3_User")).country);

    setProfilePic(JSON.parse(localStorage.getItem("gs3_User")).profilePic);
  }, []);

  useEffect(() => {
    getRoleDataList();
    onCountry(JSON.parse(localStorage.getItem("gs3_User"))?.country);
    onState(JSON.parse(localStorage.getItem("gs3_User"))?.state);
  }, []);
  //  console.log("fullCountryData", fullCountryData);

  //UPDATE
  const onSave = () => {
    setIsLoading(true);
    const pinCode = "123456";

    let formData = new FormData();
    formData.append("companyName", allData?.companyname);
    formData.append("companyWebsiteUrl", allData?.companyurl);

    formData.append("firstName", allData?.firstname);
    formData.append("lastName", allData?.lastname);
    formData.append(
      "country",
      fullCountryData?.countryCode
        ? fullCountryData?.countryCode
        : allData?.country
    );
    formData.append(
      "state",
      fullStateData?.stateCode ? fullStateData?.stateCode : allData?.state
    );
    formData.append("countryCode", fullCountryData?.countryCode);
    formData.append("stateCode", fullStateData?.stateCode);
    formData.append("city", city ? city : allData?.city);
    formData.append("address", allData?.address);
    formData.append("phone", phone ? phone : allData?.phone);
    formData.append("jobTitle", allData?.jobtitle);
    formData.append("userJobRoleId", role ? role : allData?.roleId);
    formData.append("profilePic", getImage ? getImage : profilePic);
    formData.append("zipcode", pinCode);
    getMyProfile(formData, (res) => {
      //  console.log(res, "response");
      if (res.success === true) {
        const userdata = {
          firstName: res.data.userProfile.firstName,
          lastName: res.data.userProfile.lastName,
          profilePic: res.data.userProfile.profilePic,
          id: res.data.userProfile.id,
          email: res.data.userProfile.email,
          phone: res.data.userProfile.phone,
          companyName: res.data.userProfile.companyName,
          companyWebsiteUrl: res.data.userProfile.companyWebsiteUrl,
          country: res.data.userProfile.country,
          countryCode: res.data.userProfile.countryCode,
          state: res.data.userProfile.state,
          stateCode: res.data.userProfile.stateCode,
          city: res.data.userProfile.city,
          address: res.data.userProfile.address,
          role: res.data.userProfile.role,
          jobtitle: res.data.userProfile.jobTitle,
          jobRole: res?.data?.userProfile?.UserJobRole?.name,
          roleId: res?.data?.userProfile?.UserJobRole?.id,
          verified: res.data.userProfile.verified,
          status: res.data.userProfile.status,
        };
        //   localStorage.setItem("gs3_AuthToken", res.data.accessToken);
        localStorage.setItem("gs3_User", JSON.stringify(userdata));
        toast.success(res.message);
        setIsLoading(false);
        navigate("/dashboard");
        navigate(-1);
      } else {
        setIsLoading(false);
        // console.log("nononononono");
        toast.error(res.message);
      }
    });
  };

  async function getRoleDataList() {
    setIsLoading(true);
    getAllRolelist().then(function (result) {
      const response = result.data;
      setAllRoleList(response?.data?.jobRoleList);
      setIsLoading(false);
    });
  }

  let roleDropdown = <option>Loading...</option>;
  if (roleList && roleList.length > 0) {
    roleDropdown = roleList.map((roleRow, index) => (
      <option value={roleRow.id}>{roleRow.name}</option>
    ));
  }

  const onFile = (event) => {
    //  console.log(event.target.files[0], "filee");
    if (event["target"].files.length > 0) {
      const file = event["target"].files[0];
      // setUserData({...userData, profileImage : file});
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0],
      });
      // console.log(image, "101823");
      setGetImage(file);
      setGetImageresult(file.name);
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file);
      //     reader.onload = (event) => {
      //         setGetImageresult(reader.result);
      //   };
    }
  };
  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
      // console.log(image, "101823");
    }
  };
  const onUpdateProfile = (e) => {
    // if (businessUnitName === "") {
    //     toast.error("Please type business unit name")
    // } else if (shortName === "") {
    //     toast.error("Please type short name")
    // } else if (identificationNumber === "") {
    //     toast.error("Please type BU identification number")
    // } else if (accountingKey === "") {
    //     toast.error("Please type BU general ledger key")
    // } else if (industryId === "") {
    //     toast.error("Please select industry")
    // } else if (country === "") {
    //     toast.error("Please select country")
    // } else if (state === "") {
    //     toast.error("Please select state")
    // } else if (city === "") {
    //     toast.error("Please select city")
    // } else if (pinCode === "") {
    //     toast.error("Please type zip code")
    // } else if (address === "") {
    //     toast.error("Please type your address")
    // } else {
    //     getBusinessUnit(businessUnitName, shortName,
    //         identificationNumber, accountingKey,
    //         industryId, countryData.find(c => c.isoCode === country)?.name, stateData.find(c => c.isoCode === state)?.name, city, pinCode, address,
    //         (r) => {
    //           //  console.log(r, "response")
    //             if (r.success === true) {
    //                 toast.success(r.message)
    //                 navigate("/businessunit")
    //             } else {
    //                 toast.error(r.message)
    //             }
    //         })
    // }
  };

  // console.log(allData?.role === undefined, "allData?.role");

  return (
    <div className="container-fluid">
      <div className="dbMain myProfile">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm={t("configuration") + " > "}
            title={t("my_profile")}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase">
            <form>
              <div className="browseimg">
                <div className="upld">
                  <label htmlFor="upload-button" className="uploadBtn">
                    {image.preview || profilePic ? (
                      <img
                        src={image.preview ? image.preview : profilePic}
                        alt="profile"
                        width="300"
                        height="300"
                      />
                    ) : (
                      <>
                        <span className="fa-stack fa-2x">
                          <i className="fa-solid fa-plus"></i>
                        </span>
                      </>
                    )}
                    <span className="addbtn">
                      <i className="fa-solid fa-circle-plus"></i>
                    </span>
                  </label>
                  <input
                    type="file"
                    id="upload-button"
                    style={{ display: "none" }}
                    onChange={onFile}
                  />
                  <br />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="companyname">{t("mother_company")}</label>
                  <input
                    type="text"
                    id="companyname"
                    className="form-control"
                    placeholder={t("mother_company")}
                    name="companyname"
                    value={allData?.companyname}
                    disabled={
                      JSON.parse(localStorage.getItem("gs3_User")).role ===
                      "employee"
                    }
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label htmlFor="companyurl">{t("website_url")}</label>
                  <input
                    type="text"
                    id="companyurl"
                    className="form-control"
                    placeholder={t("website_url")}
                    name="companyurl"
                    value={allData?.companyurl}
                    onChange={(e) =>
                      setAllData({ ...allData, companyurl: e.target.value })
                    }
                    disabled={
                      JSON.parse(localStorage.getItem("gs3_User")).role ===
                      "employee"
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="firstName">{t("first_name")}</label>
                  <input
                    type="text"
                    id="firstName"
                    className="form-control"
                    name="firstname"
                    placeholder={t("first_name")}
                    value={allData?.firstname}
                    onChange={(e) =>
                      setAllData({ ...allData, firstname: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="lastName">{t("last_name")}</label>
                  <input
                    type="text"
                    id="lastName"
                    className="form-control"
                    placeholder={t("last_name")}
                    name="lastname"
                    value={allData?.lastname}
                    onChange={(e) =>
                      setAllData({ ...allData, lastname: e.target.value })
                    }
                  />
                </div>
              </div>

              {JSON.parse(localStorage.getItem("gs3_User")).role ===
                "customer" && (
                <>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="country">{t("country")}</label>
                      <select
                        className="form-control"
                        id="country"
                        onChange={(e) => onCountry(e.target.value)}
                        name="country"
                      >
                        {countryData.map((con) => (
                          <option
                            value={con.countryCode}
                            selected={allData?.country === con.countryCode}
                          >
                            {con.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="state">{t("state")}</label>
                      <select
                        className="form-control"
                        id="state"
                        onChange={(e) => onState(e.target.value)}
                        name="state"
                      >
                        {stateData.map((sta) => (
                          <option
                            value={sta.stateCode}
                            selected={allData?.state === sta.stateCode}
                          >
                            {sta.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="city">{t("city")}</label>
                      <select
                        className="form-control"
                        id="city"
                        onChange={onCity}
                        name="city"
                      >
                        {cityData.map((cit) => (
                          <option
                            value={cit.name}
                            selected={allData?.city === cit.name}
                          >
                            {cit.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="address">{t("address")}</label>
                      <textarea
                        className="form-control"
                        name="address"
                        placeholder={t("address")}
                        id="address"
                        value={allData?.address}
                        onChange={(e) =>
                          setAllData({ ...allData, address: e.target.value })
                        }
                      ></textarea>
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone">{t("phone")}</label>
                  <PhoneInput
                    id="phone"
                    defaultCountry="ua"
                    value={allData?.phone}
                    className="phInp"
                    name="phone"
                    onChange={(phone) => setPhone(phone)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="email">{t("email")}</label>
                  <div className="checkmail">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder={t("email")}
                      name="email"
                      value={allData?.email}
                    />
                    <i className="fa-solid fa-circle-check"></i>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="role">{t("role")}</label>
                  <select
                    disabled={
                      JSON.parse(localStorage.getItem("gs3_User"))?.role ===
                      "employee"
                    }
                    className="form-control"
                    id="role"
                    name="role"
                    onChange={onRole}
                  >
                    <option hidden>{role ? role : t("select_job_role")}</option>
                    {roleDropdown}
                  </select>
                  {/* <select
                    disabled={
                      JSON.parse(localStorage.getItem("gs3_User"))?.role ===
                      "employee"
                    }
                    className="form-control"
                    id="role"
                    name="role"
                    onChange={onRole}
                  >
                    <option hidden>{role ? role : t("select_job_role")}</option>
                    {roleList &&
                      roleList
                        .filter(
                          (roleRow) =>
                            !roleRow.isDelete || roleRow.id === allData?.id // Include deleted role if it matches the user's current role
                        )
                        .map((roleRow) => (
                          <option
                            key={roleRow.id}
                            value={roleRow.id}
                            selected={roleRow.id === allData?.id} // Select the user's current role
                          >
                            {roleRow.name}
                          </option>
                        ))}
                  </select> */}
                </div>
              </div>

              <button type="button" className="commonButton" onClick={onSave}>
                {t("save")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Myprofile;
